import { Component, OnInit, ViewChild } from '@angular/core';
import { GrupoViewModel, FormaItemResultsViewModel, FormaViewModel } from './grupoforma.types';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { GrupoFormaService } from './grupoforma.service';

import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { ConfirmationService } from 'primeng/api';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-grupo-edit-forma-list',
    templateUrl: './grupo-edit-forma-list.component.html',
})
export class GrupoEditFormaListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;
    editMode: boolean;
    editTitle: string = 'Nuevo Grupo';
    grupo: GrupoViewModel;

    resultForma: FormaItemResultsViewModel;
    totalregistros: number = 0;
    visibilitySpinner: boolean = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private grupoFormaService: GrupoFormaService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
    ) {
        super(authService, notificationService, exceptionHandler);
        this.grupo = new GrupoViewModel();
        this.resultForma = new FormaItemResultsViewModel();
    }

    ngOnInit() {
        this.form = this.fb.group({
            Descripcion: ['', Validators.required],
            EmbalajeObligatorio: [false, Validators.required],
        });

        let id = +this.activatedRoute.snapshot.params['idGrupo'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar Grupo';

            this.grupoFormaService.getGrupo(id).subscribe(result => {
                //this.notificationService.publishBreadCrumb(result.Descripcion, this.router);
                this.editTitle += ' - ' + result.Descripcion;
                this.grupo = result;
                this.updateForm();
            });
        }

        this.loading = true;
        this.grupoFormaService.getFormaByIdGrupo(id).subscribe(result => {
            this.resultForma = result;
            this.totalregistros = this.resultForma.ResultList.length;
            this.loading = false;
        });
    }

    updateForm() {
        this.form.setValue({
            Descripcion: this.grupo.Descripcion,
            EmbalajeObligatorio: this.grupo.EmbalajeObligatorio,
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        let grupo = new GrupoViewModel();

        grupo.Descripcion = this.form.value.Descripcion;

        grupo.EmbalajeObligatorio = this.form.value.EmbalajeObligatorio;            

        grupo.Id = this.grupo.Id;

        if (this.editMode) {
            this.grupoFormaService.editGrupo(grupo).subscribe({
                next: res => {
                    this.addSuccessMessage('Grupo modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.grupoFormaService.createGrupo(grupo).subscribe({
                next: res => {
                    this.addSuccessMessage('Grupo añadido correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onAdd() {
        //this.router.navigate(["/mantenimiento/especies/forma/create", idGrupo]);
        //this.router.navigate(["/mantenimiento/especies/grupos/edit", this.grupo.Id,"formas","create"]);
        this.router.navigate([this.router.url, 'formas', 'create']);
    }

    onEdit(item: FormaViewModel) {
        //this.router.navigate(["/mantenimiento/especies/forma/edit", item.Id]);
        //this.router.navigate(["/mantenimiento/especies/grupos/edit", this.grupo.Id, "formas","edit", item.Id]);
        this.router.navigate([this.router.url, 'formas', 'edit', item.Id]);
    }

    onDelete(item: FormaViewModel) {
        //const response = confirm('¿Estás seguro?');
        //if (response) {
        //    this.grupoFormaService.deleteForma(item.Id)
        //        .subscribe(res => {
        //            this.ngOnInit();
        //        }, error => console.log(error));
        //}

        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.grupoFormaService.deleteForma(item.Id).subscribe(res => {
                    this.addSuccessMessage('Forma eliminada correctamente');
                    this.ngOnInit();
                });
            },
        });
    }

    onBack() {
        this.router.navigate(['/mantenimiento/especies/grupos']);
    }
}
